import { Outlet, useLocation } from "react-router-dom";
import classnames from "classnames";
import Header from "./components/Header";
import NavBar from "./components/NavBar";
// import Menu from "./components/Menu";
import SideBar from "./components/SideBar";
import Footer from "./components/Footer";
import Login from "./components/Login";
import "./index.less";
import { useEffect, useRef, useState } from "react";

const Layout: React.FC = () => {
  const ref = useRef<any>();
  const { pathname } = useLocation();

  const hideHeaderList = ["/forget", "/forget/", "/reset", "/reset/"];
  const isHideHeader = hideHeaderList.indexOf(pathname) > -1;

  const hideFooterList = ["/download", "/download/"];
  const isHideFooter = hideFooterList.indexOf(pathname) > -1;

  const hideSideBarList = ["/forget", "/forget/", "/reset", "/reset/"];
  const isHideSideBar = hideSideBarList.indexOf(pathname) > -1;

  const [navIsShow, setNavIsShow] = useState(true);

  useEffect(() => {
    let observerRefValue: any = null;
    const callback = (entries: any) => {
      entries.forEach((entry: any) => {
        setNavIsShow(entry.isIntersecting);
      });
    };
    const observer = new IntersectionObserver(callback);
    if (ref.current) {
      observer.observe(ref.current);
      observerRefValue = ref.current;
    }
    return () => {
      if (observerRefValue) {
        observer.unobserve(observerRefValue);
      }
    };
  }, []);

  const fixNavShow = !navIsShow;

  return (
    <>
      {isHideHeader ? null : (
        <header className="mall-header">
          <Header></Header>
          {/* <Menu></Menu> */}
          <NavBar isFixNav fixNavShow={fixNavShow}></NavBar>
        </header>
      )}
      <article
        className={classnames(
          "mall-wrappper",
          { hideHeader: isHideHeader },
          { fixNavShow: fixNavShow }
        )}
      >
        <main className="mall-main">
          <div ref={ref}>
            {isHideHeader ? null : <NavBar></NavBar>}
          </div>
          <Outlet />
          {isHideSideBar ? null : <SideBar fixNavShow={fixNavShow} />}
          {isHideFooter ? null : <Footer />}
        </main>
      </article>
      <Login />
    </>
  );
};

export default Layout;
